import type { TTimeframePreset } from '@feathr/hooks';

// Re-export shared timeframe preset type from hooks
export type { TTimeframePreset } from '@feathr/hooks';

/**
 * Donation type filter options.
 */
export type TDonationType = 'one_time' | 'recurring';

/**
 * Filter state for transaction table.
 */
export interface ITransactionFilters {
  /** Selected form IDs (empty = all forms) */
  formIds: string[];
  /** Donation types to include (empty = all types) */
  donationTypes: TDonationType[];
  /** Timeframe preset or 'custom' for date range */
  timeframe: TTimeframePreset;
  /** Custom date range (only used when timeframe === 'custom') */
  customDateRange: { start: Date | null; end: Date | null };
}

/**
 * Default filter values (no filtering applied).
 */
export const DEFAULT_FILTERS: ITransactionFilters = {
  formIds: [],
  donationTypes: [],
  timeframe: 'all_time',
  customDateRange: { start: null, end: null },
};
